// noinspection GraphQLUnresolvedReference

import axios from 'axios'
import { gql } from 'graphql-request'

import { ImagenCloudProp } from '../../../base/interfaces'
import { AccessToken } from '../../../base/models/paramsModel'
import { MyGraphQlError } from '../../../base/services/GraphqlError'

export const query = gql`
  mutation ARTICULO_IMPORTAR_IMAGEN(
    $cds: Int!
    $codigoArticulo: String!
    $codigoUnidadMedida: String!
    $file: Upload!
  ) {
    articuloImportarImagen(
      cds: $cds
      codigoArticulo: $codigoArticulo
      codigoUnidadMedida: $codigoUnidadMedida
      file: $file
    ) {
      filename
      id
      variants {
        medium
        public
        square
        thumbnail
      }
    }
  }
`

/**
 * @description Importación de imagen al articulo
 * @param cds
 * @param codigoArticulo
 * @param codigoUnidadMedida
 * @param file
 */
export const apiArticuloImportarImagen = async (
  cds: number,
  codigoArticulo: string,
  codigoUnidadMedida: string,
  file: File,
): Promise<ImagenCloudProp> => {
  try {
    // const client = new GraphQLClient(import.meta.env.ISI_API_URL)
    const token = localStorage.getItem(AccessToken)

    const variables = {
      cds,
      codigoArticulo,
      codigoUnidadMedida,
      file: null,
    }
    const formData = new FormData()
    const operations = JSON.stringify({ query: query, variables })
    formData.append('operations', operations)
    const map = {
      '0': ['variables.file'],
    }
    formData.append('map', JSON.stringify(map))
    formData.append('0', file)

    const resp = await axios({
      url: import.meta.env.ISI_API_URL,
      headers: {
        authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
      method: 'post',
      data: formData,
    })
      .then((data) => data.data)
      .catch((e) => {
        throw new Error(e)
      })
    return resp.data.articuloImportarImagen
  } catch (e: any) {
    throw new MyGraphQlError(e)
  }
}
